import { IAssetListTypesGroupped, IAssetTypes } from "../models/asset";

export const groupAssetListTypeByGroupName = (assetList: IAssetTypes[]): IAssetListTypesGroupped[] => {
    if (!assetList?.length) {
        return [];
    }

    const result: IAssetListTypesGroupped[] = [];

    for (const assetListType of assetList) {
        const groupName = 
            (assetListType.asset_desc == "Fundos de Investimento" 
                || assetListType.asset_desc == "Ações")
                    ? assetListType.asset_desc 
                    : assetListType.asset_group;

        const assetListTypeGroupped = result.find(r => r.groupName == groupName);

        if (assetListTypeGroupped) {
            if (!assetListTypeGroupped.names.map(n => n.id).includes(assetListType._id)) {
                assetListTypeGroupped.names.push({
                    id: assetListType._id,
                    name: assetListType.asset_name
                });
            }
        } else {
            result.push({
                groupName,
                names: [
                    {
                        id: assetListType._id,
                        name: assetListType.asset_name
                    }
                ]
            });
        }
    }

    return result;
}
